import { PropertyCodeSettingsSection } from '../organisms/property-code-settings-section';
import { useState } from 'react';
import { PiGearLight } from 'react-icons/pi';
import { Text } from 'src/modules/shared/components/atoms/text';
import { Panel } from 'src/modules/shared/components/molecules/panel';
import { PanelHeader } from 'src/modules/shared/components/molecules/panel/panel-header';
import { SectionSidebarMenu } from 'src/modules/shared/components/molecules/section-menu';
import { SectionHeading } from 'src/modules/shared/components/molecules/section-heading/section-heading';
import { useI18n } from 'src/modules/shared/hooks/provider-bounded/i18n';
import { EmployeesSettingsSection } from '../organisms/employees-settings-section';
import { PropertyLinksSettingsSection } from '../organisms/property-links-settings-section';

/** Groups company-wide configuration by domain; each setting owns its existing form and save flow. */
export function TenantSettingsPage() {
  const { t } = useI18n();
  const [activeDomain, setActiveDomain] = useState('properties');

  return (
    <Panel className="h-full overflow-auto" variant="neutral">
      <PanelHeader className="px-4 py-4 sm:px-6">
        <div className="flex items-center gap-4">
          <PiGearLight className="h-8 w-8 shrink-0" aria-hidden />
          <div className="space-y-1">
            <Text as="h2" size="h2" weight="medium">
              {t('settings.tenant.title')}
            </Text>
          </div>
        </div>
      </PanelHeader>
      <div className="grid max-w-6xl items-start gap-6 p-4 sm:p-6 lg:grid-cols-[12rem_minmax(0,1fr)]">
        <nav aria-label={t('settings.tenant.domains')}>
          <SectionSidebarMenu
            items={[
              {
                id: 'properties',
                label: t('settings.tenant.properties.title'),
              },
              { id: 'agents', label: t('settings.employees.title') },
            ]}
            activeId={activeDomain}
            onSelect={setActiveDomain}
            variant="neutral"
            appearance="soft"
            contentClassName="mt-0"
          />
        </nav>
        <div className="min-w-0">
          <div
            id="tabpanel-properties"
            role="tabpanel"
            aria-label={t('settings.tenant.properties.title')}
            hidden={activeDomain !== 'properties'}
          >
            <section
              className="space-y-4"
              aria-label={t('settings.tenant.properties.title')}
            >
              <SectionHeading
                title={t('settings.tenant.properties.title')}
                description={t('settings.tenant.properties.description')}
              />
              <PropertyCodeSettingsSection />
              <PropertyLinksSettingsSection />
            </section>
          </div>
          <div
            id="tabpanel-agents"
            role="tabpanel"
            aria-label={t('settings.employees.title')}
            hidden={activeDomain !== 'agents'}
          >
            <section
              className="space-y-4"
              aria-label={t('settings.employees.title')}
            >
              <SectionHeading
                title={t('settings.employees.title')}
                description={t('settings.employees.description')}
              />
              <EmployeesSettingsSection />
            </section>
          </div>
        </div>
      </div>
    </Panel>
  );
}
